import { OpenTalkCreateType, OpenTalkUpdateType } from 'types';
import { base } from './';

const PATH = '/open-talk';

const get = (id: string) => base.get(`${PATH}/${id}`);

const post = (data: OpenTalkCreateType) => base.post(PATH, data);

const patch = ({ id, ...data }: OpenTalkUpdateType) =>
  base.patch(`${PATH}/${id}`, data);

export { get, post, patch };
